import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class InventuraProvider extends BaseApi {
	async uzavritInventuru(id: number | string): Promise<Record<string, any>> {
		return this.fetch(`/${this.area}/${this.controller}/Uzavreni/${id}`);
	}

	async oductovatKorekciPnc(params: { ndSkladId: number }): Promise<Record<string, any>> {
		return this.fetch(`/${this.area}/${this.controller}/OductovaniKorekcePNC`, params);
	}
}

export const apiProvider = new InventuraProvider(DMS_MODULE, NAME);
